"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsInstanceDetail_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var EFormsInstanceHistoryLog_1 = require("./EFormsInstanceHistoryLog");
var EFormsInstanceDetail_Factory = /** @class */ (function () {
    function EFormsInstanceDetail_Factory() {
    }
    EFormsInstanceDetail_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CollectedByUser: User_1.User_Factory.CreateIncoming(model.CollectedByUser),
            CollectedByUserId: model.CollectedByUserId,
            HistoryLogs: model.HistoryLogs && model.HistoryLogs.map(function (i) { return EFormsInstanceHistoryLog_1.EFormsInstanceHistoryLog_Factory.CreateIncoming(i); }),
            RecordId: model.RecordId,
        };
        return result;
    };
    EFormsInstanceDetail_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CollectedByUser: User_1.User_Factory.CreateOutgoing(model.CollectedByUser),
            CollectedByUserId: model.CollectedByUserId,
            HistoryLogs: model.HistoryLogs && model.HistoryLogs.map(function (i) { return EFormsInstanceHistoryLog_1.EFormsInstanceHistoryLog_Factory.CreateOutgoing(i); }),
            RecordId: model.RecordId,
        };
        return result;
    };
    return EFormsInstanceDetail_Factory;
}());
exports.EFormsInstanceDetail_Factory = EFormsInstanceDetail_Factory;
